import { html } from 'lit';
import type { LandingEditorElementDefinition } from '../editor/landingEditorRegistry.js';

type MediaDefinition = LandingEditorElementDefinition & { path: string };

/**
 * Shared media (image/video) preview with a remove action. Kept in a single place and provided via
 * the editor context so the canvas view and the properties panel render one identical control
 * instead of duplicating it. Depends only on the two field helpers, injected by the context owner.
 */
export const createRenderMediaPreview = (deps: {
  fieldValueForDefinition: (definition: MediaDefinition) => unknown;
  updateField: (definition: MediaDefinition, value: string) => void;
}) => {
  return (definition: MediaDefinition) => {
    const value = deps.fieldValueForDefinition(definition);
    if (!value) return html`<p class="vp-editor-muted">Keine Datei ausgewählt.</p>`;
    const removeButton = html`
      <button type="button" class="vp-editor-remove-media" @click=${() => deps.updateField(definition, '')}>
        <span class="icon-[material-symbols--delete-outline]"></span> Entfernen
      </button>
    `;
    if (definition.kind === 'video') {
      return html`
        <video class="vp-editor-asset-preview" src=${value} muted controls playsinline></video>
        ${removeButton}
      `;
    }
    if (definition.kind === 'track') {
      return html`
        <p class="vp-editor-muted"><span class="icon-[material-symbols--subtitles-outline]"></span> ${value}</p>
        ${removeButton}
      `;
    }
    return html`
      <img class="vp-editor-asset-preview" src=${value} alt="" />
      ${removeButton}
    `;
  };
};
